var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPlanDetailLoading = function SvgPlanDetailLoading(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 892,
    height: 219,
    viewBox: "0 0 892 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000976562,
    width: 892,
    height: 219,
    rx: 2.72697,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.72697C0 1.22091 1.22091 0 2.72697 0H889.273C890.779 0 892 1.22091 892 2.72697V96H0V2.72697Z",
    fill: "#F3F3F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.72697C0 1.22091 1.22091 0 2.72697 0H889.273C890.779 0 892 1.22091 892 2.72697V94H0V2.72697Z",
    fill: "#F3F3F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 683,
    y: 129,
    width: 185,
    height: 56,
    rx: 2.72697,
    fill: "#F3F3F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 24,
    width: 393,
    height: 24,
    rx: 2.72697,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 339,
    y: 129,
    width: 215,
    height: 56,
    rx: 2.72697,
    fill: "#F3F3F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 129,
    width: 185,
    height: 56,
    rx: 2.72697,
    fill: "#F3F3F4"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlanDetailLoading);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODkyIiBoZWlnaHQ9IjIxOSIgdmlld0JveD0iMCAwIDg5MiAyMTkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHk9IjAuMDAwOTc2NTYyIiB3aWR0aD0iODkyIiBoZWlnaHQ9IjIxOSIgcng9IjIuNzI2OTciIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0wIDIuNzI2OTdDMCAxLjIyMDkxIDEuMjIwOTEgMCAyLjcyNjk3IDBIODg5LjI3M0M4OTAuNzc5IDAgODkyIDEuMjIwOTEgODkyIDIuNzI2OTdWOTZIMFYyLjcyNjk3WiIgZmlsbD0iI0YzRjNGNCIvPgo8cGF0aCBkPSJNMCAyLjcyNjk3QzAgMS4yMjA5MSAxLjIyMDkxIDAgMi43MjY5NyAwSDg4OS4yNzNDODkwLjc3OSAwIDg5MiAxLjIyMDkxIDg5MiAyLjcyNjk3Vjk0SDBWMi43MjY5N1oiIGZpbGw9IiNGM0YzRjQiLz4KPHJlY3QgeD0iNjgzIiB5PSIxMjkiIHdpZHRoPSIxODUiIGhlaWdodD0iNTYiIHJ4PSIyLjcyNjk3IiBmaWxsPSIjRjNGM0Y0Ii8+CjxyZWN0IHg9IjI1MCIgeT0iMjQiIHdpZHRoPSIzOTMiIGhlaWdodD0iMjQiIHJ4PSIyLjcyNjk3IiBmaWxsPSIjRDlEOUQ5Ii8+CjxyZWN0IHg9IjMzOSIgeT0iMTI5IiB3aWR0aD0iMjE1IiBoZWlnaHQ9IjU2IiByeD0iMi43MjY5NyIgZmlsbD0iI0YzRjNGNCIvPgo8cmVjdCB4PSIyNCIgeT0iMTI5IiB3aWR0aD0iMTg1IiBoZWlnaHQ9IjU2IiByeD0iMi43MjY5NyIgZmlsbD0iI0YzRjNGNCIvPgo8L3N2Zz4K";